import React from "react";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaInstagram,
  FaGithub,
} from "react-icons/fa";
import { contactImg } from "../../assets/index";

const ContactLeft = () => {
  return (
    <div className="w-full lgl:w-[35%] h-full bg-gradient-to-r from-[#1e2024] to-[#23272b] p-4 lgl:p-8 rounded-lg shadow-shadowOne flex flex-col gap-8 justify-center">
      <img
        className="w-full h-64 object-cover rounded-lg mb-2"
        src={contactImg}
        alt="contactImg"
      />
      <div className="flex flex-col gap-4">
        <h3 className="text-3xl font-bold text-white">Rajaram Sahoo</h3>
        <p className="text-lg font-normal text-gray-400">
          MERN Stack Developer
        </p>
        <p className="text-base text-gray-400 tracking-wide">
          Greetings! I'm Rajaram Sahoo, a skilled MERN stack developer with a
          knack for crafting elegant and efficient web solutions. Let's
          collaborate and bring your ideas to life!
        </p>
        <p className="text-base text-gray-400 flex items-center gap-2">
          Phone: <span className="text-lightText">+91 7008309629</span>
        </p>
        <p className="text-base text-gray-400 flex items-center gap-2">
          Email:{" "}
          <span className="text-lightText">rajaramsahoo1998@gmail.com</span>
        </p>
      </div>
      <div className="flex flex-col gap-4">
        <h2 className="text-base uppercase font-titleFont mb-4">Find me in</h2>
        <div className="flex gap-4">
          <a
            href="https://github.com/rajaramsahoo"
            target="_blank"
            rel="noreferrer"
          >
            <span className="bannerIcon" title="Github">
              <FaFacebookF />
            </span>
          </a>
          <a
            href="https://github.com/rajaramsahoo"
            target="_blank"
            rel="noreferrer"
          >
            <span className="bannerIcon" title="Github">
              <FaInstagram />
            </span>
          </a>
          <a
            href="https://github.com/rajaramsahoo"
            target="_blank"
            rel="noreferrer"
          >
            <span className="bannerIcon" title="Github">
              <FaLinkedinIn />
            </span>
          </a>
          <a
            href="https://github.com/rajaramsahoo"
            target="_blank"
            rel="noreferrer"
          >
            <span className="bannerIcon" title="Github">
              <FaGithub />
            </span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default ContactLeft;
